import { APP_STORAGE_PREFIX } from "./appStorage";

const PREFIX = `${APP_STORAGE_PREFIX}favourite_rsvp_dismissed:`;

export function favouriteRsvpDismissKey(eventId, occurrenceDate) {
  return `${PREFIX}${eventId}:${occurrenceDate}`;
}

export function isFavouriteRsvpDismissed(eventId, occurrenceDate) {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(favouriteRsvpDismissKey(eventId, occurrenceDate)) === "1";
  } catch {
    return false;
  }
}

export function dismissFavouriteRsvp(eventId, occurrenceDate) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(favouriteRsvpDismissKey(eventId, occurrenceDate), "1");
  } catch {
    // ignore
  }
}

export function filterUndismissedFavouritePending(items) {
  return (items || []).filter(
    (item) => !isFavouriteRsvpDismissed(item.event_id, item.occurrence_date),
  );
}
